import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./style.css";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import loadConfig from "../../../Services/Api/ApiServices";
// import { UpdateAdvertisingPlan } from "../../Redux/Reducers/AdvertisingAndMediaPlanForTheProject";
// import UpdatestateApplicationInformationPage from "../../Services/ApplicantInformationPage/UpdateApplicantInformation";
// import UpdateSectoreInformationProject from "../../Services/ProjectInformationPage/SectoreInformationProject/UpdateSectoreInformationProject";
// import UpdateProjectPlan from "../../Services/ProjectInformationPage/ProjectPlanDetails/UpdateProjectPlan";
// import UpdateInformationAboutProject from "../../Services/ProjectInformationPage/ProjectInformation/UpdateInformationAboutProject";
// import UpdateGenderMainstreaming from "../../Services/ProjectInformationPage/InformationAboutTheTargetGroup/UpdateGenderMainstreaming";
// import UpdateProjectImpact from "../../Services/ProjectInformationPage/ExpectedUnoactProjectTargetGroup/UpdateProjectImpact";
import { useParams } from "react-router-dom";
import { UpdateMainResarcherPage } from "../../../Redux/Reducers/Submitter/MainResearcherInformation";
import { UpdateResearchProposalInformation } from "../../../Redux/Reducers/Submitter/ResearchProposalInformation";
import { UpdateConflictOfInterestList } from "../../../Redux/Reducers/Submitter/ConflictsOfInterestAndResearchEthics";
// import { decryptToken } from "../../Services/Account/EncryptionParams";
// import { UpdateInformationAboutProjectt } from "../../Redux/Reducers/ProjectInformationPage/ProjectInformation";

function Navbar(props) {
  const ApplicationInfo = useSelector(
    (state) => state.ApplicationInformationReducers.ApplicationInformation
  );

  ///////////////////////////////////////////////////////////////////////////////////////////
  // to read params url
  const location = useLocation();
  // استخراج GUID باستخدام Regular Expression
  const match = window.location.pathname; // قراءة النص بعد أول "/"
  const encryptedToken = match.split("/");
  var guid = encryptedToken[encryptedToken.length - 1];
  console.log(guid, "dsssssssssfefefef");

  const ActiveRound = useSelector((state) => state.RoundReducers.ActiveRound);
  const ApplicationInformation = useSelector(
    (state) => state.ApplicationInformationReducers.ApplicationInformation
  );

  ///////////////////////////////////////////////////////////////////////////////////////////

  /////////////////////////////////////////////////////////////////////////////////////////////
  // Definition use state for application url
  const [ResearchProposalInformation, setResearchProposalInformation] =
    useState("");
  const [
    MainResearcherInformainContainer,
    setMainResearcherInformainContainer,
  ] = useState("");


const [reportStagePage,setreportStagePage] = useState("");


  const [WorkPlanEstimatedBudget, setWorkPlanEstimatedBudget] = useState("");
  const [Attachments, setAttachments] = useState("");

  const [InformationProject, setInformationProject] = useState("");
  const [InformationProjectSub, setInformationProjectSub] = useState("");
  //معلومات عن الفئة المستهدفة ضمن المشروع
  const [InformationTargetGroupProject, setInformationTargetGroupProject] =
    useState("");
  //تفاصيل خطة عمل المشروع
  const [DetailsProjectWorkPlan, setDetailsProjectWorkPlan] = useState("");
  //الأثر المتوقع للمشروع على الفئة المستهدفة ومعايير الاستدامة
  const [
    ExpectedImpactProjectTargetGroupSustainabilityStandards,
    setExpectedImpactProjectTargetGroupSustainabilityStandards,
  ] = useState("");
  //معلومات عن القطاع وأصالة المشروع
  const [
    InformationSectorOriginalityProject,
    setInformationSectorOriginalityProject,
  ] = useState("");
  //أعضاء فريق العمل - الخبرات السابقة - بناء وحشد الشراكات
  const [TeamMembersPreviousExperience, setTeamMembersPreviousExperience] =
    useState("");
  //الخطة الإعلانية والإعلامية للمشروع
  const [AdvertisingAndMediaPlan, setAdvertisingAndMediaPlan] = useState("");
  //الموازنة والاطار الزمني
  const [BudgetTimeFrame, setBudgetTimeFrame] = useState("");
  // المرفقات والتعهد
  const [AttachmentsAndPledge, setAttachmentsAndPledge] = useState("");
  const [ReportStage, setReportStage] = useState("");
  const [Transfers, setTransfers] = useState("");
  //console.log(encryptedToken,"dfeeefdfsafdsafdsf");
  console.log(guid, "dddddddddedwqdwqd");

  /////////////////////////////////////////////////////////////////////////////////////////////
  useEffect(() => {
    if (props.location == "manager") {
      setMainResearcherInformainContainer(
        `/manager/MainResearcherInformainContainer/${guid}`
      );
      setWorkPlanEstimatedBudget(`/manager/WorkPlanEstimatedBudget/${guid}`);

      setResearchProposalInformation(
        `/manager/ResearchProposalInformation/${guid}`
      );
      setInformationProjectSub(
        `/manager/InformationProject/InformationProjectSub/${guid}`
      );
      setInformationTargetGroupProject(
        `/manager/InformationProject/InformationTargetGroupProject/${guid}`
      );
      setAdvertisingAndMediaPlan(`/manager/AdvertisingAndMediaPlan/${guid}`);
      setBudgetTimeFrame(
        `/manager/ConflictOfInterestAndResearchEthics/${guid}`
      );
      setAttachmentsAndPledge(`/manager/AttachmentsAndPledge/${guid}`);
      setReportStage(`/manager/ReportStage/${guid}`);
      setTransfers(`/manager/Transfers/${guid}`);
      setAttachments(`/manager/AttachmentsAndPledge/${guid}`);
      setreportStagePage(`/manager/ReportStage/${guid}`)
    } else {
      setResearchProposalInformation("/ResearchProposalInformation");
      setMainResearcherInformainContainer("/MainResearcherInformainContainer");
      setWorkPlanEstimatedBudget("/WorkPlanEstimatedBudget");
      setAttachments("/AttachmentsAndPledge");

      setInformationProjectSub("/InformationProject/InformationProjectSub");
      setInformationTargetGroupProject(
        `/InformationProject/InformationTargetGroupProject`
      );
      setAdvertisingAndMediaPlan(`/AdvertisingAndMediaPlan`);
      setBudgetTimeFrame(`/ConflictOfInterestAndResearchEthics`);
      setAttachmentsAndPledge(`/AttachmentsAndPledge`);
      setReportStage(`/ReportStage`);
      setTransfers(`/Transfers`);
      setreportStagePage("/ReportStage")
    }
  }, []);

  const [activeLink, setActiveLink] = useState(window.location.pathname);
  const [menuOpen, setMenuOpen] = useState(false);
  const AppGuid = useParams();
  const [jsonData, setJsonData] = useState();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      MainResearcherInformation:
        state.MainResearcherInformation.MainResearcherInformain,
      InfoScientificFoundation:
        state.InformationAboutScientificInstitution.InfoScientificFoundation,
      ResearchProposalInformation:
        state.ResearchProposalInformation.ResearchProposalInformation,
      ConflictOfInterest: state.ConflictOfInterest.ConflictOfInterest,
    };
  });
  //console.log(AppGuid, "lskdlksdiiiidsd");

  const handleLinkClick = async (path) => {
    const shouldDisableFields = !(
      ActiveRound == ApplicationInformation?.aI_RoundYearId &&
      ApplicationInformation?.sU_ST_MRI_ApplicationStatus?.canEdit &&
      window.location.href.includes("manager") == false
    );
    // [,]
    //في حال تم الضغط على اي زر من المنيو يقوم بحفظ المعلومات عند التنقل في حال كانت المعلومات موجوده
    if (!shouldDisableFields) {
      if (
        Object.keys(state.MainResearcherInformation).length !== 0 &&
        Object.keys(state.InfoScientificFoundation).length !== 0
      ) {
        const saved = await dispatch(
          UpdateMainResarcherPage({
            sU_NT_MRI_MainResearcherInformainUpdateModel:
              state.MainResearcherInformation,
            sU_NT_MRI_InformationAboutTheScientificFoundationUpdateModel:
              state.InfoScientificFoundation,
          })
        );
      }
      //--------------------ResearchProposalInformation--------------------------
      if (Object.keys(state.ResearchProposalInformation).length !== 0) {
        const saved = await dispatch(
          UpdateResearchProposalInformation({
            ...state.ResearchProposalInformation,
          })
        );
      }
      if (Object.keys(state.ConflictOfInterest).length !== 0) {
        // const saved = await dispatch(
        //   UpdateConflictOfInterestList({
        //     ...state.ConflictOfInterest,
        //   })
        // );
      }
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم حفظ المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1000,
        // width: "500px",
      });
    }

    navigate(`/SRFund${path}`);
    setActiveLink(`/SRFund${path}`);
    setMenuOpen(false);
  };
  //[,]
  // to change design after clicked on
  const getBackgroundColor = (path) => {
    return activeLink === path || activeLink.includes(path)
      ? "#fff"
      : "#dbdbdbab";
  };
  const getTextColor = (path) => {
    return activeLink === path || activeLink.includes(path)
      ? "#034e84"
      : "#034e84";
  };
  const getboxShadow = (path) => {
    return activeLink === path || activeLink.includes(path)
      ? "1px 1px 1px 1px rgb(9 54 111 / 51%)"
      : "none";
  };
  const gettextDecoration = (path) => {
    return activeLink === path || activeLink.includes(path) ? "none" : "none";
  };
  const getBorderBottom = (path) => {
    return activeLink === path || activeLink.includes(path)
      ? "3.5px solid #18647f"
      : "none";
  };
  // let jsonData = {};
  const dataJson = async () => {
    let jsonData = await loadConfig();

    setJsonData(jsonData);
  };

  useEffect(() => {
    dataJson();
  }, []);

  // console.log(jsonData.ApplicationInfoTip.url,"gg");

  return (
    <>
      {jsonData ? (
        <nav style={{ width: "100%", zIndex: "999" }}>
          <div className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
            &#9776;
          </div>
          <ul className={`navbar nav-links ${menuOpen ? "open" : ""}`}>
            {/* ///////////////////////// */}
            <li
              className="MainResearcherInformainContainer "
              onClick={() => handleLinkClick(MainResearcherInformainContainer)}
              style={{
                backgroundColor: getBackgroundColor(
                  MainResearcherInformainContainer
                ),
                boxShadow: getboxShadow(MainResearcherInformainContainer),
                textDecoration: gettextDecoration(
                  MainResearcherInformainContainer
                ),
                borderBottom: getBorderBottom(MainResearcherInformainContainer),
              }}
              title={jsonData?.applicationInformationTap?.nameEN}
            >
              <Link
                to={MainResearcherInformainContainer}
                style={{
                  color: getTextColor(MainResearcherInformainContainer),
                }}
              >
                {jsonData?.PrincipalInvestigatorInformationTap?.nameAR}
              </Link>
              <a
                className="tipIcon"
                href={jsonData?.MainResercharTip?.url}
                target="_blank"
                rel="noopener noreferrer"
                title={jsonData?.MainResercharTip?.PlaceHolder}
              >
                <i id="sds" class={jsonData?.MainResercharTip?.icon}></i>
              </a>
            </li>
            {/* ///////////////////////// */}

            <li
              className="ResearchProposalInformation"
              onClick={() => handleLinkClick(ResearchProposalInformation)}
              style={{
                backgroundColor: getBackgroundColor(
                  ResearchProposalInformation
                ),
                boxShadow: getboxShadow(ResearchProposalInformation),
                textDecoration: gettextDecoration(ResearchProposalInformation),
                borderBottom: getBorderBottom(ResearchProposalInformation),
              }}
              title={jsonData?.ResearchProposalInformationTap?.nameEN}
            >
              <Link
                to={ResearchProposalInformation}
                style={{ color: getTextColor(ResearchProposalInformation) }}
              >
                {jsonData?.ResearchProposalInformationTap?.nameAR}
              </Link>
              <a
                className="tipIcon"
                href={jsonData?.ResearchProposalTip?.url}
                target="_blank"
                rel="noopener noreferrer"
                title={jsonData?.ResearchProposalTip?.PlaceHolder}
              >
                <i id="sds" class={jsonData?.ResearchProposalTip?.icon}></i>
              </a>
            </li>
            {/* ///////////////////////// */}

            <li
              className="WorkPlanEstimatedBudget"
              onClick={() => handleLinkClick(WorkPlanEstimatedBudget)}
              style={{
                backgroundColor: getBackgroundColor(WorkPlanEstimatedBudget),
                boxShadow: getboxShadow(WorkPlanEstimatedBudget),
                textDecoration: gettextDecoration(WorkPlanEstimatedBudget),
                borderBottom: getBorderBottom(WorkPlanEstimatedBudget),
              }}
              title={jsonData?.BusinessPlanAndBudgetTap?.nameEN}
            >
              <Link
                to={WorkPlanEstimatedBudget}
                style={{ color: getTextColor(WorkPlanEstimatedBudget) }}
              >
                {jsonData?.BusinessPlanAndBudgetTap?.nameAR}
              </Link>
              <a
                className="tipIcon"
                href={jsonData?.BusinessPlanAndBudgetTip?.url}
                target="_blank"
                rel="noopener noreferrer"
                title={jsonData?.BusinessPlanAndBudgetTip?.PlaceHolder}
              >
                <i
                  id="sds"
                  class={jsonData?.BusinessPlanAndBudgetTip?.icon}
                ></i>
              </a>
            </li>
            {/* ///////////////////////// */}

            <li
              className="ConflictOfInterestAndResearchEthics"
              onClick={() => handleLinkClick(BudgetTimeFrame)}
              style={{
                backgroundColor: getBackgroundColor(BudgetTimeFrame),
                boxShadow: getboxShadow(BudgetTimeFrame),
                textDecoration: gettextDecoration(BudgetTimeFrame),
                borderBottom: getBorderBottom(BudgetTimeFrame),
              }}
              title={jsonData?.ConflictOfInterestAndResearchEthicsTap?.nameEN}
            >
              <Link
                to={BudgetTimeFrame}
                style={{ color: getTextColor(BudgetTimeFrame) }}
              >
                {jsonData?.ConflictOfInterestAndResearchEthicsTap?.nameAR}
              </Link>
              <a
                className="tipIcon"
                href={jsonData?.ConflictOfInterestTip?.url}
                target="_blank"
                rel="noopener noreferrer"
                title={jsonData?.ConflictOfInterestTip?.PlaceHolder}
              >
                <i id="sds" class={jsonData?.ConflictOfInterestTip?.icon}></i>
              </a>
            </li>
            {/* ///////////////////////// */}

            <li
              className="AttachmentsAndPledge"
              onClick={() => handleLinkClick(Attachments)}
              style={{
                backgroundColor: getBackgroundColor(Attachments),
                boxShadow: getboxShadow(Attachments),
                textDecoration: gettextDecoration(Attachments),
                borderBottom: getBorderBottom(Attachments),
              }}
              title={jsonData?.AttachmentsAndPledgeTap?.nameEN}
            >
              <Link
                to={Attachments}
                style={{ color: getTextColor(Attachments) }}
              >
                {jsonData?.AttachmentsAndPledgeTap?.nameAR}
              </Link>
              <a
                className="tipIcon"
                href={jsonData?.AttachmentTip?.url}
                target="_blank"
                rel="noopener noreferrer"
                title={jsonData?.AttachmentTip?.PlaceHolder}
              >
                <i id="sds" class={jsonData?.AttachmentTip?.icon}></i>
              </a>
            </li>
            {/* ///////////////////////// */}

            {state?.ApplicationInformation?.aI_ApplicationStatusId ==
            "561563df-1a04-4d40-8293-3f32c6ae57b5" ? (
              <li
                className="ReportStage"
                onClick={() => handleLinkClick(ReportStage)}
                style={{
                  backgroundColor: getBackgroundColor(ReportStage),
                  boxShadow: getboxShadow(ReportStage),
                  textDecoration: gettextDecoration(ReportStage),
                  borderBottom: getBorderBottom(ReportStage),
                }}
                title={jsonData?.applicationInformationTap?.nameEN}
              >
                <Link
                  to={ReportStage}
                  style={{ color: getTextColor(ReportStage) }}
                >
                  {jsonData?.RS_ReportStagesNav?.nameAR}
                </Link>
                <a
                  className="tipIcon"
                  href={jsonData?.RS_ReportStagesNav?.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={jsonData?.ReportsStageTip?.PlaceHolder}
                >
                  <i id="sds" class={jsonData?.ReportsStageTip?.icon}></i>
                </a>
              </li>
            ) : (
              ""
            )}
            {/* { state.ApplicationInformation?.aI_ApplicationStatusId ==
            "561563df-1a04-4d40-8293-3f32c6ae57b5" ? */}
            {state.ReportStatusByApplicationGuid?.pR_ReportStatusGuid ==
              "80cd0c1e-b4d3-4fbf-acd5-5627c455915b" ||
            state.ReportStatusByApplicationGuid?.pR_ReportStatusGuid ==
              "8dd3e82f-6bc0-43d7-9439-8a63f655a263" ? (
              <li
                className="Transfers"
                onClick={() => handleLinkClick(Transfers)}
                style={{
                  backgroundColor: getBackgroundColor(Transfers),
                  boxShadow: getboxShadow(Transfers),
                  textDecoration: gettextDecoration(Transfers),
                  borderBottom: getBorderBottom(Transfers),
                }}
                title={jsonData?.applicationInformationTap?.nameEN}
              >
                <Link to={Transfers} style={{ color: getTextColor(Transfers) }}>
                  {jsonData?.RS_TransfersNav?.nameAR}
                </Link>
                <a
                  className="tipIcon"
                  href={jsonData?.RS_TransfersNav?.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={jsonData?.ReportsStageTip?.PlaceHolder}
                >
                  <i id="sds" class={jsonData?.ReportsStageTip?.icon}></i>
                </a>
              </li>
            ) : (
              ""
            )}
            {/* /////////////report stage//////////// */}
            {ApplicationInfo?.applicationStatusId ==
            "f4c6c3e1-c49e-4361-8c86-c3015da12750" ? (
              <>
                <li
                  className="reportStagePage "
                  onClick={() =>
                    handleLinkClick(reportStagePage)
                  }
                  style={{
                    backgroundColor: getBackgroundColor(
                      reportStagePage
                    ),
                    boxShadow: getboxShadow(reportStagePage),
                    textDecoration: gettextDecoration(
                      reportStagePage
                    ),
                    borderBottom: getBorderBottom(
                      reportStagePage
                    ),
                  }}
                  title={jsonData?.applicationInformationTap?.nameEN}
                >
                  <Link
                    to={reportStagePage}
                    style={{
                      color: getTextColor(reportStagePage),
                    }}
                  >
                    {jsonData?.ReportStageNamePage?.nameAR}
                  </Link>
                  <a
                    className="tipIcon"
                    href={jsonData?.MainResercharTip?.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={jsonData?.MainResercharTip?.PlaceHolder}
                  >
                    <i id="sds" class={jsonData?.MainResercharTip?.icon}></i>
                  </a>
                </li>
              </>
            ) : (
              <></>
            )}
          </ul>
          {menuOpen && (
            <div className="overlaynav" onClick={() => setMenuOpen(false)} />
          )}
        </nav>
      ) : (
        ""
      )}
    </>
  );
}

export default Navbar;
